import { FormContext } from '~/components/forms/FormContext';
import { useContext } from 'react';
import { getBrowserTimezone } from '~/lib/DateTime';
import useCurrentBusiness from '~/lib/useCurrentBusiness.jsx';

const useClientTimezone = () => {
    const business = useCurrentBusiness();

    const isFixedTimezone = business?.fixed_timezone;
    if (isFixedTimezone) {
        return business?.timezone;
    } else {
        return getBrowserTimezone();
    }
};

export default useClientTimezone;
